import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Typography } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute'; // Import ProtectedRoute
import AdminLogin from './pages/AdminLogin';
import AdminSentences from './pages/AdminSentences';
import AdminResults from './pages/AdminResults';
import AdminQrCode from './pages/AdminQrCode';
import AdminUsers from './pages/AdminUsers';
import AdminParticipants from './pages/AdminParticipants';
import AdminGitHub from './pages/AdminGitHub';
import AdminEmail from './pages/AdminEmail';
import AdminNotifications from './pages/AdminNotifications';
import AdminSentenceFiles from './pages/AdminSentenceFiles';
import CollectionPage from './pages/public/CollectionPage';
import PhotoUploadPage from './pages/public/PhotoUploadPage';
import ReviewPage from './pages/public/ReviewPage';
import CompletionPage from './pages/public/CompletionPage';
import WelcomePage from './pages/public/WelcomePage';
import AdminLayout from './pages/AdminLayout';

// Define a simple theme
const theme = createTheme({
    palette: {
        primary: {
            main: '#1976d2', // Example primary color
        },
        secondary: {
            main: '#dc004e', // Example secondary color
        },
    },
});

// --- Public Pages --- //

// --- Text Collection Page --- //


function App() {
    return (
        <AuthProvider>
            <ThemeProvider theme={theme}>
                <Routes>
                    {/* Public Routes */}
                    <Route path="/welcome/:uuid" element={<WelcomePage />} />
                    <Route path="/envelope/:uuid" element={<CollectionPage />} />
                    <Route path="/photos/:uuid" element={<PhotoUploadPage />} />
                    <Route path="/review/:uuid" element={<ReviewPage />} />
                    <Route path="/complete/:uuid" element={<CompletionPage />} />

                    {/* Admin Routes */}
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route
                        path="/admin"
                        element={
                            <ProtectedRoute>
                                <AdminLayout />
                            </ProtectedRoute>
                        }
                    >
                        {/* Nested Admin Routes - Rendered via Outlet in AdminLayout */}
                        <Route index element={<AdminSentences />} />
                        <Route path="sentences" element={<AdminSentences />} />
                        <Route path="sentence-files" element={<AdminSentenceFiles />} />
                        <Route path="results" element={<AdminResults />} />
                        <Route path="qrcode" element={<AdminQrCode />} />
                        <Route path="participants" element={<AdminParticipants />} />
                        <Route path="github" element={<AdminGitHub />} />
                        <Route path="email" element={<AdminEmail />} />
                        <Route path="notifications" element={<AdminNotifications />} />
                        <Route path="users" element={<AdminUsers />} />
                    </Route>

                    {/* Catch-all for unknown routes (optional) */}
                    <Route path="*" element={<Typography sx={{mt: 5, textAlign: 'center'}}>Página não encontrada</Typography>} />
                </Routes>
            </ThemeProvider>
        </AuthProvider>
    );
}

export default App;

